<template>
  <div class="advertising-management main-second-bg">
    <div class="advertising-management-header a-3-bd clearfix">
      <c-navTab
        activeClassName="b-1-cl"
        activeColor="a-12-bg"
        className="b-2-cl"
        :currentTab="currentTab"
        :navTab="navTab"
        :lineHeight="lineHeight"
        :marginRight="marginRight"
        @currentType="currentType"
      />
    </div>
    <div class="filterArea">
      <c-select
        :value="status"
        @onChanges="statusChanged"
        name="status"
        :options="statusOptions"
        width="120px"
        newStyleFormat
        fill
        size="small"
      />
    </div>
    <div class="advertising-management-center">
      <c-table
        :imgMap="imgMap"
        :colorMap="colorMap"
        :classes="classes"
        :loading="loading"
        :headClasses="headClasses"
        :bodyClasses="bodyClasses"
        :lineClasses="lineClass"
        :columns="columns"
        :dataList="dataList"
        @elementClick="closeData"
      />
      <c-pagination
        v-show="count > 10"
        :total="count"
        :current-page="page"
        :display="pageSize"
        @pagechange="pagechange"
      >
      </c-pagination>
    </div>
    <c-dialog
      :showFlag="dialogFlag"
      paddingBottom="14px"
      :confirmLoading="dialogConfirmLoading"
      :confirmDisabled="dialogConfirmDisabled"
      @close="dialogClose"
      @confirm="dialogConfirm"
      :titleText="titleText"
    >
      <p class="dialog-p">{{ $t("personal.dialog.closeAdPrompt") }}</p>
    </c-dialog>
  </div>
</template>

<script>
import {
  formatTime, fixD, imgMap, colorMap, getCoinShowName,
} from '@/utils';

export default {
  name: 'advertisingManagement',
  data() {
    return {
      // table loading
      titleText: this.$t('personal.dialog.closeAd'),
      imgMap,
      colorMap,
      loading: false,
      // uid
      uid: '',
      // 横向导航参数
      currentTab: 1,
      marginRight: 48, // 距离右边的距离
      lineHeight: '55',
      // table相关
      columns: [
        {
          title: this.$t('personal.advertisingManagement.columns')[0],
          align: 'left',
          width: '120px',
          classes: '',
        },
        {
          title: this.$t('personal.advertisingManagement.columns')[1],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.advertisingManagement.columns')[2],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.advertisingManagement.columns')[3],
          align: 'left',
          width: '150px',
        },
        {
          title: this.$t('personal.advertisingManagement.columns')[4],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.advertisingManagement.columns')[5],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.advertisingManagement.columns')[6],
          align: 'left',
          width: '100px',
        },
      ],
      dataList: [],
      classes: '',
      headClasses: '',
      bodyClasses: '',
      lineClass: '',
      // page相关
      count: 0,
      page: 1,
      pageSize: 10,
      // 弹框相关
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
      // 要关闭的广告id
      advertId: '',
      status: 'all',
      // status 广告状态 1发布中 2交易中 3过期 4关闭
      // assets.otcAccount.all 全部
      // personal.state.release 发布中
      // personal.state.trading 交易中
      // personal.state.overdue 过期
      // personal.state.close 关闭
      // personal.state.closed 已关闭
      statusOptions: [
        {
          value: this.$t('assets.otcAccount.all'),
          code: 'all',
        },
        {
          value: this.$t('personal.state.release'),
          code: '1',
        },
        {
          value: this.$t('personal.state.trading'),
          code: '2',
        },
        {
          value: this.$t('personal.state.overdue'),
          code: '3',
        },
        {
          value: this.$t('personal.state.close'),
          code: '4',
        },
      ],
    };
  },
  computed: {
    navTab() {
      return [
        {
          name: this.$t('personal.advertisingManagement.navTab')[0],
          index: 1,
        },
        {
          name: this.$t('personal.advertisingManagement.navTab')[1],
          index: 2,
        },
      ];
    },
    baseData() {
      return this.$store.state.baseData;
    },
    otcPersonAds() {
      return this.$store.state.personal.otcPersonAds;
    },
    otcCloseWanted() {
      return this.$store.state.personal.otcCloseWanted;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    adType() {
      return this.currentTab === 1 ? 'buy' : 'sell';
    },
  },
  watch: {
    otcPersonAds(otcPersonAds) {
      if (otcPersonAds !== null) {
        if (this.publicInfo) {
          this.loading = false;
          this.count = otcPersonAds.data.count;
          this.dataProcessin(otcPersonAds.data.adList, this.$store.state.baseData.market);
        }
      }
    },
    otcCloseWanted(otcCloseWanted) {
      if (otcCloseWanted !== null) {
        this.dialogConfirmLoading = false;
        if (otcCloseWanted.text === 'success') {
          this.$bus.$emit('tip', { text: otcCloseWanted.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.getList();
          this.dialogFlag = false;
        } else {
          this.$bus.$emit('tip', { text: otcCloseWanted.msg, type: 'error' });
          this.$store.dispatch('resetType');
          this.$bus.$emit('getCode-clear', 'phone');
        }
      }
    },
    userInfo(userInfo) {
      if (userInfo) {
        this.getList();
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { userInfo } = this.$store.state.baseData;
      if (userInfo !== null) {
        this.loading = true;
        this.getList();
      }
    },
    statusChanged(item) {
      this.status = item.code;
      this.init();
    },

    getList() {
      this.uid = this.userInfo.id;
      const info = {
        uid: this.uid,
        pageSize: this.pageSize,
        page: this.page,
        status: this.status === 'all' ? undefined : this.status,
        adType: this.adType,
      };
      this.$store.dispatch('otcPersonAds', info);
    },

    dataProcessin(list, market) {
      const dataList = [];
      if (list !== null) {
        list.forEach((obj) => {
          dataList.push({
            id: [obj.advertId, this.uid],
            data: [
              formatTime(obj.createTime),
              obj.advertId,
              getCoinShowName(obj.coin, market.coinList),
              fixD(
                obj.price,
                market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()]
                  ? Number(market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()])
                  : this.$store.state.baseData.defaultFiatPrecision,
              ) + obj.payCoin,
              fixD(obj.volume, market.coinList[obj.coin].showPrecision),
              this.stateHand(obj.status),
              [
                {
                  type: 'button',
                  text: this.$t('personal.tool.view'),
                  iconClass: [''],
                  eventType: 'view',
                  classes: '',
                },
                {
                  // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                  type: this.typeShow(obj.status),
                  text: this.showText(obj.status),
                  iconClass: [''],
                  eventType: this.eventType(obj.status),
                  classes: [this.showClasses(obj.status)],
                },
              ],
            ],
          });
        });
        this.dataList = dataList;
      }
    },

    currentType(data) {
      this.currentTab = data.index;
      this.loading = true;
      this.getList();
    },

    closeData(type, id) {
      if (type === 'close') {
        [this.dialogFlag, this.advertId] = [true, id[0]];
      } else if (type === 'view') {
        this.$router.push(`/otcTrade?orderId=${id[0]}&userId=${id[1]}`);
      }
    },
    dialogClose() {
      this.dialogFlag = false;
    },
    dialogConfirm() {
      this.dialogConfirmLoading = true;
      const info = { advertId: this.advertId };
      this.$store.dispatch('otcCloseWanted', info);
    },

    pagechange(page) {
      this.page = page;
      this.getList();
    },

    stateHand(num) {
      switch (num) {
        case 1:
          return this.$t('personal.state.release');
        case 2:
          return this.$t('personal.state.trading');
        case 3:
          return this.$t('personal.state.overdue');
        default:
          return this.$t('personal.state.close');
      }
    },
    showText(num) {
      switch (num) {
        case 1:
          return this.$t('personal.state.close');
        case 2:
          return this.$t('personal.state.trading');
        case 3:
          return this.$t('personal.state.overdue');
        default:
          return this.$t('personal.state.closed');
      }
    },
    eventType(num) {
      switch (num) {
        case 1:
          return 'close';
        default:
          return '';
      }
    },
    showClasses(num) {
      switch (num) {
        case 1:
          return '';
        default:
          return 'b-2-cl banned-click';
      }
    },
    typeShow(num) {
      switch (num) {
        case 1:
          return 'button';
        default:
          return 'label';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.advertising-management {
  width: 100%;
  min-height: 800px;
  border-radius: 6px;
  .advertising-management-header {
    font-size: 14px;
    width: 100%;
    padding-left: 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }

  .filterArea {
    padding: 24px;
  }
  .advertising-management-center {
    width: 100%;
  }
  .dialog-p {
    font-size: 14px;
    padding: 40px 0;
  }
  .banned-click {
    cursor: default !important;
    :hover {
      background: none !important;
    }
  }
}
</style>
